var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{attrs:{"mb-0":""}},[_vm._v(" "+_vm._s(_vm.$t('errors.error_404.content'))+" ")]),_c('v-layout',{attrs:{"justify-center":""}},[_c('v-btn',{staticStyle:{"margin-left":"-28px"},attrs:{"color":"sz_transparent_red"},on:{"click":function($event){return _vm.redirect()}}},[_vm._v(" "+_vm._s(_vm.$t('buttons.ok'))+" ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }